import HipchatChevronDownIcon from '@atlaskit/icon/glyph/hipchat/chevron-down';
import Search from '../../assets/v2/Pricing/search.svg';
import styled from 'styled-components';
import { SectionParent } from '../../components/StyledComponents';
import React from 'react';
require('./pricing.scss');

const itemArray = [
  {
    title: 'Android Enterprise Device Provisioning',
    properties: [
      {
        heading: 'Seamless, No-Touch Provisioning',
        essential: 'No',
        pro: 'Yes',
        typical: 'No',
      },
      {
        heading: '6-Tap QR Code Provisioning',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Yes',
      },
      {
        heading: 'External Tool for Provisioning',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
      {
        heading: 'Android for Work Provisioning',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Yes',
      },
      {
        heading: 'Google ZTE Enrollment',
        essential: 'No',
        pro: 'Yes',
        typical: 'No',
      },
    ],
  },

  {
    title: 'Android Managed Device Templates',
    properties: [
      {
        heading: 'System Lockdown',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Yes',
      },
      {
        heading: 'Android System Settings',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Yes',
      },
      {
        heading: 'Custom Settings App',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'No',
      },
      {
        heading: 'Device Security',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Yes',
      },
      {
        heading: 'OS Optimization',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'No',
      },
      {
        heading: 'Updated Security Policies',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Yes',
      },
      {
        heading: 'Mass Reboot',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
      {
        heading: 'User Management',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Yes',
      },
      {
        heading: 'Factory Reset Protection',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'No',
      },
      {
        heading: 'Google Account Restrictions',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'No',
      },
      {
        heading: 'ADB Protection',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'No',
      },
      {
        heading: 'Call & SMS Restrictions',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'No',
      },
      {
        heading: 'Whitelabel',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'No',
      },
    ],
  },

  {
    title: 'Device Lists & Groups',
    properties: [
      {
        heading: 'Device Status',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Yes',
      },
      {
        heading: 'Device Groups',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Yes',
      },
      {
        heading: 'Device Search',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Yes',
      },
      {
        heading: 'List, Grid & Map View',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
      {
        heading: 'Device, & Group Commands, Actions',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Yes',
      },
      {
        heading: 'Device Reboot',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Yes',
      },
      {
        heading: 'Lock Device Screen',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Yes',
      },
      {
        heading: 'Device Online Status (Heartbeat)',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
      {
        heading: 'Wipe Devices',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Yes',
      },
      {
        heading: 'WiFi Access Point',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Yes',
      },
      {
        heading: 'Preloaded App Actions',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Yes',
      },
      {
        heading: 'Scheduled OS Updates',
        essential: 'Yes(Esper Enhanced Android only)',
        pro: 'Yes(Esper Enhanced Android only)',
        typical: 'Yes',
      },
      {
        heading: 'Scheduled App Updates',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
      {
        heading: 'Approval Workflow',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
    ],
  },

  {
    title: 'App Management',
    properties: [
      {
        heading: 'Upload Private Apps',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Yes',
      },
      {
        heading: 'Easy Remote Install / Uninstall Apps ',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Yes',
      },
      {
        heading: 'Schedule Installs / Updates',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'No',
      },
      {
        heading: 'Block / Permit Apps',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Yes',
      },
      {
        heading: 'Configure App Permissions',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Yes',
      },
      {
        heading: 'Configure App State ',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Yes',
      },
      {
        heading: 'Clear App Data',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Yes',
      },
      {
        heading: 'App Version Management',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Yes',
      },
      {
        heading: 'Bulk-Enroll New App Versions',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Yes',
      },
      {
        heading: 'Auto-Update Apps',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Yes',
      },
      {
        heading: 'Group App Install',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Yes',
      },
      {
        heading: 'Switch to Multi-App Mode',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Yes',
      },
      {
        heading: 'Password Control',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
    ],
  },

  {
    title: 'Play for Work & AOSP Support',
    properties: [
      {
        heading: 'Support for AOSP (Non-GMS Certified) Android',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'No',
      },
      {
        heading: 'Play for Work Provisioning (Managed Google Play)',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
      {
        heading: 'Custom Collections for Managed Google Play ',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
      {
        heading: 'Approve / Disapprove Play Apps',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Yes',
      },
      {
        heading: 'Authorize App Permissions',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
      {
        heading: 'Custom Email Notifications',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
    ],
  },

  {
    title: 'Security, Alerts & Geofencing',
    properties: [
      {
        heading: 'Custom Alerts',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Yes',
      },
      {
        heading: 'Custom Alert Notifications',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Yes',
      },
      {
        heading: 'Network Alerts',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
      {
        heading: 'Battery Alerts',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'No',
      },
      {
        heading: 'Device Alerts',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Yes',
      },
      {
        heading: 'App Alerts',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Yes',
      },
      {
        heading: 'Usage Alerts',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
      {
        heading: 'Security Alerts',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
      {
        heading: 'Rich Alert Engine',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
      {
        heading: 'Geofencing',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'No',
      },
      {
        heading: 'Geofence Breach Actions',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'No',
      },
    ],
  },
  {
    title: 'Compliance Policy',
    properties: [
      {
        heading: 'Create-Once, Deploy Anywhere Policies',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Yes',
      },
      {
        heading: 'Device Password Policy',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Yes',
      },
      {
        heading: 'Granular User App Permissions',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
      {
        heading: 'Granular System Update Policy',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
      {
        heading: 'Granular Display / Non-Display of Android Settings App',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
      {
        heading: 'Display / Non-Display of Flashlight',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
      {
        heading: 'Factory Reset Protection',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
      {
        heading: 'Display / Non-Display of Device Info',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
      {
        heading: 'Whitelabeling',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
      {
        heading: 'Google Account Restrictions',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
      {
        heading: 'Allow / Disallow Lock-Screen in Sleep Mode',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
      {
        heading: 'Allow / Disallow Safe Mode Login',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
      {
        heading: 'Display / Non-Display of Notification Bar',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
      {
        heading: 'Allow / Disallow Screenshots',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
      {
        heading: 'Allow / Disallow USB Connectivity',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
      {
        heading: 'Allow / Disallow Camera Access',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
      {
        heading: 'Allow / Disallow NFC',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
      {
        heading: 'Allow / Disallow Play Store ',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
      {
        heading: 'Granular Wi-Fi Setting Control',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
      {
        heading: 'Edit Date & Time',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
      {
        heading: 'Allow / Disallow App Uninstall',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
      {
        heading: 'Enable / Disable Google Voice Assistant',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
      {
        heading: 'Allow / Disallow Local App Installs',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
    ],
  },
  {
    title: 'Reporting',
    properties: [
      {
        heading: 'Daily Reports',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Yes',
      },
      {
        heading: 'Custom Reports',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
      {
        heading: 'Device Analytics Dashboard',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Yes',
      },
      {
        heading: 'Company Dashboard',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'No',
      },
      {
        heading: 'Alert Management',
        essential: 'No',
        pro: 'Yes',
        typical: 'Yes',
      },
    ],
  },
  {
    title: 'Beyond MDM | Device Orchestration ',
    properties: [
      {
        heading: 'Android for x86',
        essential: 'No',
        pro: 'Yes',
        typical: 'No',
      },
      {
        heading: 'Device Telemetry',
        essential: 'No',
        pro: 'Yes',
        typical: 'No',
      },
      {
        heading: 'Advanced DevOps Deployment Pipelines',
        essential: 'No',
        pro: 'Yes',
        typical: 'No',
      },
      {
        heading: 'Define Pipeline Action',
        essential: 'No',
        pro: 'Yes',
        typical: 'No',
      },
      {
        heading: 'Define Pipeline Action Triggers',
        essential: 'No',
        pro: 'Yes',
        typical: 'No',
      },
      {
        heading: 'Granular Pipeline Stage Definition',
        essential: 'No',
        pro: 'Yes',
        typical: 'No',
      },
      {
        heading: 'Granular Pipeline Acceptance Criteria',
        essential: 'No',
        pro: 'Yes',
        typical: 'No',
      },
    ],
  },
  {
    title: 'Android Developer Tools ',
    properties: [
      {
        heading: 'APIs',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'No',
      },
      {
        heading: 'SDKs',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'No',
      },
      {
        heading: 'CLIs',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'No',
      },
      {
        heading: 'Tools for Android Studio',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'No',
      },
      {
        heading: 'Cloud Management Console',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'No',
      },
    ],
  },
  {
    title: 'Remote Management',
    properties: [
      {
        heading: 'Remote Viewer & Control',
        essential: 'Yes(On supported devices)',
        pro: 'Yes(On supported devices)',
        typical: 'Sometimes',
      },
      {
        heading: 'Remote Debugging',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'No',
      },
      {
        heading: 'Remote Support',
        essential: 'No',
        pro: 'Yes',
        typical: 'Sometimes',
      },
      {
        heading: 'Remote Wipe',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
      {
        heading: 'Tracking Devices',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
      {
        heading: 'Queue Actions for Offline Devices',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
      {
        heading: 'Remotely Change Kiosk Apps',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
      {
        heading: 'Remote Reboot',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
      {
        heading: 'Remote Device Lockdown',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
      {
        heading: 'Remote Group Actions',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'Sometimes',
      },
    ],
  },

  {
    title: 'Android DevOps',
    properties: [
      {
        heading: 'API Management',
        essential: 'No',
        pro: 'Yes',
        typical: 'Very rarely',
      },
      {
        heading: 'CI/CD Pipelines',
        essential: 'No',
        pro: 'Yes',
        typical: 'Very rarely',
      },
      {
        heading: 'Access to Telemetry Data',
        essential: 'No',
        pro: 'Yes',
        typical: 'No',
      },
      {
        heading: 'Virtual Device Lab',
        essential: 'Yes',
        pro: 'Yes',
        typical: 'No',
      },
    ],
  },
];

const StyledInputs = styled.input`
  :focus {
    color: #495057;
    border-color: #9568d0;
    outline: 0;
    box-shadow: 0 0 0 0.1rem rgba(0, 123, 255, 0.25);
    color: black;
    /* background-image: none; */
  }
  background: url(${Search}) no-repeat, #f4f5f7;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  @media (max-width: 520px) {
    font-size: 12px;
  }
  line-height: 1.43;
  ::placeholder {
    color: #a1a4b8;
    font-weight: bold;
    opacity: 1; /* Firefox */
  }
  padding: 1.07em 0.5em;
  margin-top: 10px;
  height: 50px;
  width: 100%;
  border: solid 1.5px #ffffff;
  padding: 0.475rem 0.75rem 0.475rem 1.5rem;
  border-radius: 25px;
  background-position-y: center;
  background-position-x: 25px;
  background-repeat: no-repeat;
  text-indent: 32px;
  background-size: 18px 18px;
`;

const Section = styled(SectionParent)`
  background-repeat: no-repeat;
  background-color: #f3f3f3;
  padding-top: 3rem !important;
  padding-bottom: 5rem !important;
  @media (max-width: 1440px) and (min-width: 768px) {
    padding: 0rem 10rem;
  }
  @media (max-width: 520px) {
    padding-top: 2rem !important;
    /* padding-bottom: 5rem !important; */
  }
  width: 100%;
  display: grid;
  justify-items: center;
`;

const Heading = styled.div`
  font-size: 36px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #151828;
  text-align: center;
  padding-bottom: 3rem;
  @media (max-width: 520px) {
    font-size: 20px;
    width: 100%;
  }
`;

const SubHeading = styled.div`
  font-size: 21px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #9568d0;
  padding-bottom: 2rem;
  @media (max-width: 520px) {
    text-align: center;
    font-size: 18px;
  }
`;

const SearchHolder = styled.div`
  width: 60%;
  @media (max-width: 520px) {
    width: 90%;
  }
`;

const CompareContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  justify-content: center;
  padding-top: 2rem;
  width: 95%;
  @media (max-width: 520px) {
    width: 100%;
  }
`;

const BlankHeader = styled.div`
  display: grid;
  grid-column: span 2;
`;

const HeaderColumn = styled.div`
  display: grid;
  grid-column: span 1;
  font-size: 21px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #151828;
  justify-content: center;
  align-items: center;
  padding: 2rem 0;
  @media (max-width: 768px) {
    font-size: 12px;
    padding: 1.4rem 0;
    padding-left: 10px;
  }
`;

const TitleSection = styled.div`
  display: grid;
  background: #ffffff;
  grid-column: span 6;
  grid-template-columns: repeat(6, 1fr);
  border-bottom: solid 1px #f0f0f0;
  padding: 0;
  border-radius: 5px;
`;

const PropertySection = styled(TitleSection)`
  border-bottom: none;
  animation-name: example2;
  animation-duration: 1s;
  padding: 0.5rem 0;
  @keyframes example2 {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;
const PropertyTitle = styled.div`
  display: grid;
  grid-column: span 2;
  font-size: 15px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 3;
  letter-spacing: normal;
  color: #626679;
  padding-left: 36px;
  @media (max-width: 768px) {
    font-size: 12px;
    line-height: normal;
    padding-left: 10px;
  }
`;
const PropertyAvailable = styled.div`
  display: grid;
  grid-column: span 1;
  align-items: center;
  font-size: 15px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #626679;
  text-align: center;
  @media (max-width: 768px) {
    font-size: 12px;
  }
`;
const CompareTitle = styled.div`
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #151828;
  display: grid;
  grid-column: span 2;
  align-items: center;
  justify-content: start;
  padding-left: 36px;
  @media (max-width: 768px) {
    font-size: 12px;
  }
  @media (max-width: 520px) {
    padding-left: 10px;
  }
`;

const ArrowSection = styled.div`
  display: grid;
  grid-column: span 1;
  justify-self: end;
  position: relative;
  cursor: pointer;
  width: 5rem;
  @media (max-width: 768px) {
    justify-content: end;
  }
  @media (max-width: 520px) {
    width: 2.5rem;
  }
`;
const ArrowHolder = styled.div`
  width: fit-content;
  display: grid;
  position: absolute;
  top: 1rem;
  left: 0;
  @media (max-width: 800px) {
    top: 0.5rem;
  }
`;
const ParentWrapper = styled.div`
  display: grid;
  grid-column: span 6;
  grid-template-columns: repeat(6, 1fr);
  padding-bottom: 1rem;
  cursor: pointer;
`;
export default class PricingSectionSix extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      searchValue: '',
      valueArray: itemArray,
      selected: -1,
    };
  }
  handleSearch = (event: any) => {
    this.setState(
      {
        searchValue: event.target.value,
      },
      () => this.filterArray()
    );
  };

  filterArray = () => {
    const search = this.state.searchValue.toLowerCase();
    const loopArray = itemArray;
    if (search === '') {
      this.setState({
        valueArray: itemArray,
      });
    } else {
      const tempArray = loopArray.filter((item: any) => {
        if (
          item.properties.some((item2: any) =>
            item2.heading.toLowerCase().includes(search)
          )
        ) {
          return item;
        }
      });

      this.setState({ valueArray: tempArray });
    }
  };

  handleShowProperties = (index: number) => {
    if (index === this.state.selected) {
      this.setState({
        selected: -1,
      });
    } else {
      this.setState({
        selected: index,
      });
    }
  };
  render() {
    return (
      <Section>
        <Heading>
          Compare Android Enterprise Device
          <br /> Management Plans {'&'} Features
        </Heading>
        <SubHeading>Esper vs. Alternative MDM / EMM / UEM</SubHeading>
        <SearchHolder>
          <StyledInputs
            id="email"
            value={this.state.searchValue}
            aria-label="Email"
            maxLength={149}
            onChange={this.handleSearch}
            type="email"
            placeholder={'Search for product Plans and Features'}
            name="Work Email"
          />
        </SearchHolder>
        <CompareContainer>
          <BlankHeader />
          <HeaderColumn>Esper Essentials </HeaderColumn>
          <HeaderColumn>Esper Pro </HeaderColumn>
          <HeaderColumn>Typical MDM </HeaderColumn>
          <HeaderColumn />
          {this.state.valueArray.map((item: any, index: number) => (
            <ParentWrapper
              key={item.title + index}
              onClick={() => this.handleShowProperties(index)}
            >
              <TitleSection>
                <CompareTitle>{item.title}</CompareTitle>
                <HeaderColumn /> <HeaderColumn /> <HeaderColumn />
                <ArrowSection>
                  <ArrowHolder
                    className={
                      this.state.selected === index
                        ? 'rotate-head'
                        : 'reverse-head'
                    }
                  >
                    <HipchatChevronDownIcon label="arrow" size="large" />
                  </ArrowHolder>
                </ArrowSection>
              </TitleSection>
              {item.properties.map(
                (item1: any, index1: number) =>
                  this.state.selected === index && (
                    <PropertySection
                      style={
                        index1 % 2 === 0
                          ? { background: '#ffffff' }
                          : { background: '#f8fafd' }
                      }
                    >
                      <PropertyTitle>{item1.heading}</PropertyTitle>
                      <PropertyAvailable>{item1.essential}</PropertyAvailable>
                      <PropertyAvailable>{item1.pro}</PropertyAvailable>
                      <PropertyAvailable>{item1.typical}</PropertyAvailable>
                      <PropertyAvailable />
                    </PropertySection>
                  )
              )}
            </ParentWrapper>
          ))}
        </CompareContainer>
      </Section>
    );
  }
}
